// Import global CSS so Webpack knows about it
//import "../wwwroot/css/site.css";

import { CookieHelper } from "./Common/CookieHelper";
import { GlobalData } from "./Common/GlobalData";
import { HtmlHelpers } from "./Common/HtmlHelpers";
import { BigPictureHelper } from "./Common/KendoHelpers";
import { UrlHelper } from "./Common/UrlHelper";
import { ChecklistSummary } from "./GeneralReports/ChecklistSummary";
import { ETFsHistory } from "./GeneralReports/ETFsHistory";
import { BuyPointAnalysis as LeaderboardBuyPointAnalysis } from "./IBD/Leaderboard/BuypointAnalysis";
import { Edit as MarketSchoolEdit } from "./IBD/Leaderboard/MarketSchool/Edit";
import { Index as MarketSchoolIndex } from "./IBD/Leaderboard/MarketSchool/Index";
import { Edit as TheBigPictureEdit } from "./IBD/Leaderboard/TheBigPicture/Edit";
import { Index as TheBigPictureIndex } from "./IBD/Leaderboard/TheBigPicture/Index";
import { BasesForming } from "./IBD/MarketSmith/BasesForming";
import { BasesFormingDiffs } from "./IBD/MarketSmith/BasesFormingDiffs";
import { EarlyBuyPatterns } from "./IBD/MarketSmith/EarlyBuyPatterns";
import { MovingUpInRank } from "./IBD/MarketSmith/IndustryGroups/MovingUpInRank";
import { PatternsChangedBlank } from "./IBD/MarketSmith/PatternsChangedBlank";
import { PivotPointChanges } from "./IBD/MarketSmith/PivotPointChanges";
import { PivotPointPatterns } from "./IBD/MarketSmith/PivotPointPatterns";
import { RsLineBlueDotPatterns } from "./IBD/MarketSmith/RsLineBlueDotPatterns";
import { RsLineBlueDotTrendTemplates } from "./IBD/MarketSmith/RsLineBlueDotTrendTemplates";
import { RsLineNewHigh } from "./IBD/MarketSmith/RSLineNewHigh";
import { StockChecklist } from "./IBD/MarketSmith/StockChecklist";
import { BuyPointAnalysis as WebsiteBuyPointAnalysis } from "./IBD/Website/BuyPointAnalysis";
import { Create as TheNewAmericaCreate } from "./IBD/Website/TheNewAmerica/Create";
import { Importer } from "./ImportData/Importer";
import { Quandl } from "./ImportData/Quandl";
import { GenerateReports } from "./ImportData/ValueLine/GenerateReports";
import { ImportFiles } from "./ImportData/ValueLine/ImportFiles";
import { SelectSymbols } from "./ImportData/ValueLine/SelectSymbols";
import { AccountsGainLoss } from "./PersonalReports/AccountsGainLoss";
import { AccountsLots } from "./PersonalReports/AccountsLots";
import { HeatMap } from "./PersonalReports/HeatMap";
import { StocksToBuySell } from "./PersonalReports/StocksToBuySell";
import { StocksToBuySellUpdate } from "./PersonalReports/StocksToBuySellUpdate";
import { WatchList } from "./PersonalReports/WatchList";
import { WatchListReport } from "./PersonalReports/WatchListReport";
import { AccountSelector } from "./Portfolio/AccountManager/AccountSelector";
import { TabStrip as AccountManagerTabStrip } from "./Portfolio/AccountManager/TabStrip";
import { WatchList as PortfolioWatchList } from "./Portfolio/WatchListManager/WatchList";
import { WatchListSelector } from "./Portfolio/WatchListManager/WatchListSelector";
import { MovementComparison } from "./TechnicalReports/MovementComparison";
import { MovingAverageCrossoverDaily } from "./TechnicalReports/MovingAverageCrossoverDaily";
import { MovingAverageCrossoverHistory } from "./TechnicalReports/MovingAverageCrossoverHistory";
import { MovingAverages } from "./TechnicalReports/MovingAverages";
import { MovingAveragesHistory } from "./TechnicalReports/MovingAveragesHistory";
import { OverboughtOversold } from "./TechnicalReports/OverboughtOversold";
import { OverboughtOversoldCount } from "./TechnicalReports/OverboughtOversoldCount";
import { RelativeStrengthLine } from "./TechnicalReports/RelativeStrengthLine";
import { RelativeStrengthLineComparison } from "./TechnicalReports/RelativeStrengthLineComparison";
import { CompanyReports } from "./ValueLine/CompanyReports";

document.addEventListener("DOMContentLoaded", () => {
    const path = UrlHelper.getPageIdentifier();

    switch (path) {
        case '':
        case 'home':
        case 'home/index':
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            CookieHelper.set('userTimeZone', userTimeZone);

            new WatchListSelector();
            new AccountSelector(false);
            break;

        case 'importdata/json':
        case 'importdata/excel':
            new Importer();
            break;

        case 'importdata/quandl':
            new Quandl();
            break;

        case 'ibd/marketsmith/pivotpointchanges':
            PivotPointChanges.getInstance();
            break;

        case 'ibd/marketsmith/pivotpointpatterns':
            new PivotPointPatterns();
            break;

        case 'importdata/valueline/importconverterfile':
        case 'importdata/valueline/importibdmscurrentdatafile':
        case 'importdata/valueline/importvaluelinefiles':
        case 'importdata/valueline/importfinalfiles':
            ImportFiles.getInstance();
            break;

        case 'importdata/valueline/selectsymbols':
            BigPictureHelper.showBigPictureData();
            new SelectSymbols();
            break;

        case 'importdata/valueline/generatereports':
            new Importer();
            GenerateReports.getInstance();
            break;

        case 'ibd/website/thenewamerica/create':
            new TheNewAmericaCreate();
            break;

        case 'ibd/website/buypointanalysis':
            new WebsiteBuyPointAnalysis();
            break;

        case 'ibd/leaderboard/thebigpicture':
        case 'ibd/leaderboard/thebigpicture/index':
            new TheBigPictureIndex();
            break;

        case 'ibd/leaderboard/thebigpicture/edit':
            new TheBigPictureEdit();
            break;

        case 'ibd/leaderboard/marketschool':
        case 'ibd/leaderboard/marketschool/index':
            new MarketSchoolIndex();
            break;

        case 'ibd/leaderboard/marketschool/edit':
            new MarketSchoolEdit();
            break;

        case 'ibd/leaderboard/buypointanalysis':
            new LeaderboardBuyPointAnalysis();
            break;

        case 'ibd/marketsmith/industrygroups/movingupinrank':
            MovingUpInRank.getInstance();
            break;

        case 'ibd/marketsmith/basesforming':
            new BasesForming();
            break;

        case 'ibd/marketsmith/basesformingdiffs':
            new BasesFormingDiffs();
            break;

        case 'ibd/marketsmith/earlybuypatterns':
            new EarlyBuyPatterns();
            break;

        case 'ibd/marketsmith/patternschangedblank':
            new PatternsChangedBlank();
            break;

        case 'ibd/marketsmith/rslinebluedotpatterns':
            new RsLineBlueDotPatterns();
            break;

        case 'ibd/marketsmith/rslinebluedottrendtemplates':
            new RsLineBlueDotTrendTemplates();
            break;

        case 'ibd/marketsmith/rslinenewhigh':
            new RsLineNewHigh();
            break;

        case 'ibd/marketsmith/stockchecklist':
            const sclIndex = parseInt(HtmlHelpers.getUrlParameter('index') || '');
            new StockChecklist(sclIndex);
            break;

        case 'valueline/companyreports':
            new CompanyReports();
            break;

        case 'portfolio/watchlistmanager':
        case 'portfolio/watchlistmanager/index':
            $('#watchListName').html(CookieHelper.get(GlobalData.WATCHLIST_MANAGER_WATCHLIST_NAME_COOKIE));
            BigPictureHelper.showBigPictureData();
            new PortfolioWatchList();
            break;

        case 'portfolio/accountmanager':
        case 'portfolio/accountmanager/index':
            $('#accountName').html(CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE));
            new AccountSelector(true);
            BigPictureHelper.showBigPictureData();
            AccountManagerTabStrip.getInstance();
            break;

        case 'generalreports/checklistsummary':
            const clsIndex = parseInt(HtmlHelpers.getUrlParameter('index') || '');
            new ChecklistSummary(clsIndex);
            break;

        case 'generalreports/etfshistory':
            new ETFsHistory();
            break;

        case 'personalreports/accountsgainloss':
            new AccountsGainLoss();
            break;

        case 'personalreports/accountslots':
            const accountsLotsUrlParams = new URLSearchParams(window.location.search);
            const userId = accountsLotsUrlParams.get('userId')!;
            new AccountsLots(userId);
            break;

        case 'personalreports/heatmap':
            const heatMapUrlParams = new URLSearchParams(window.location.search);
            const useAccount = heatMapUrlParams.get('useAccount');
            new HeatMap(useAccount == 'true');
            break;

        case 'personalreports/stockstobuysell':
            new StocksToBuySell();
            break;

        case 'personalreports/stockstobuysellupdate':
            StocksToBuySellUpdate.getInstance();
            break;

        case 'personalreports/watchlist':
            WatchList.getInstance();
            break;

        case 'personalreports/watchlistreport':
            WatchListReport.getInstance();
            break;

        case 'technicalreports/movementcomparison':
            new MovementComparison();
            break;

        case 'technicalreports/movingaveragecrossoverdaily':
            new MovingAverageCrossoverDaily();
            break;

        case 'technicalreports/movingaveragecrossoverhistory':
            new MovingAverageCrossoverHistory();
            break;

        case 'technicalreports/movingaverages':
            new MovingAverages();
            break;

        case 'technicalreports/movingaverageshistory':
            const maHistorySymbol = HtmlHelpers.getUrlParameter('symbol') ?? '';
            new MovingAveragesHistory(maHistorySymbol);
            break;

        case 'technicalreports/overboughtoversold':
            new OverboughtOversold();
            break;

        case 'technicalreports/overboughtoversoldcount':
            new OverboughtOversoldCount();
            break;

        case 'technicalreports/relativestrengthline':
            var rsLineSymbol = HtmlHelpers.getUrlParameter('symbol') ?? '';
            new RelativeStrengthLine(rsLineSymbol);
            break;

        case 'technicalreports/relativestrengthlinecomparison':
            new RelativeStrengthLineComparison();
            break;

        default: {
            console.error('Add this page to the big switch statement in EntryPoint.ts.');
        }
    }
});
